import { ButtonMantine, Group, Modal, ModalProps, Stack, Text, ThemeIcon, Title } from 'ui';
import { IconCircleCheck } from 'ui/Icons';

import { useTransferAccountsModalGroupProvider } from '../../../organisms/modals/TransferAccountsModalGroup/TransferAccountModalGroup.context';

const CashbackDonationsFlowConfirmModalContent = () => {
  const { close } = useTransferAccountsModalGroupProvider({
    id: 'ConfirmDonation',
  });

  return (
    <Stack>
      <Group justify="center">
        <ThemeIcon size="64" c="mint.7" variant="transparent">
          <IconCircleCheck size="64" color="mint.7" />
        </ThemeIcon>
      </Group>
      <Stack gap="xs">
        <Title order={2}>Thank you for donating!</Title>
        <Text fz="sm" c="gray">
          Please check your email in a few minutes to view your receipt.
        </Text>
      </Stack>
      <ButtonMantine onClick={close}>Okay, thanks!</ButtonMantine>
    </Stack>
  );
};

interface CashbackDonationsFlowConfirmModalProps extends ModalProps {
  modalProps?: Partial<ModalProps>;
}

const CashbackDonationsFlowConfirmModal = ({
  opened,
  onClose,
  modalProps,
}: CashbackDonationsFlowConfirmModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} withCloseButton={false} {...modalProps}>
      <CashbackDonationsFlowConfirmModalContent />
    </Modal>
  );
};

const CashbackDonationsFlowConfirmModalWrapper = () => {
  const { opened, close, props } = useTransferAccountsModalGroupProvider({
    id: 'ConfirmDonation',
  });

  return <CashbackDonationsFlowConfirmModal opened={opened} onClose={close} modalProps={props} />;
};

export { CashbackDonationsFlowConfirmModalWrapper as CashbackDonationsFlowConfirmModal };
